import researchSlice from './ResearchSlice';
import vtSlice from './ViewTypeSlice';
import stageSlice from './CompetitonStageSlice';
import competitionsSlice from './Competitions'
import animatorSlice from './AnimatorSlice'
import TagsSlice from './Tags';
import navbarSearchSlice from './NavbarSearch';
import InfinityProjectsSlice from './InfinityProjects';
import HseContextListSlice from './hseCurrentContext';
import TeamsSlice from './Teams/TeamsSlice';
import langSlice from 'shared/components/__ADDONS__/__LANG__/Slice';
import GeoTagModalStateSlice from './geoTagsModal';
import CurrentProject from "./CurrentProject";
import MobileMenuModalStateSlice from './mobileMenuOpen';
import MapsSlice from "./MapsSlice";
import OrganizationsSlice from "./OrganizationsSlice";
import ProjectsGridSlice from "./ProjectsGridSlice";
import CourseInfoListSlice from './CourseInfoListSlice';
import orderSlice from "../features/QueuePaymenrt/slices/OrderSlice";
import userCurrenciesSlice from "../features/QueuePaymenrt/slices/userCurrenciesSlice";
import sendGiftSlice from "../features/QueuePaymenrt/slices/SendGiftSlice";
import commonSlice from "../features/QueuePaymenrt/slices/commonSlice";
import WideCoverSlice from './WideCoverSlice';
import LMSSlice from "./LMSSlice";
import TagPageSlice from './TagPageSlice';
import OpenModalSlice from './OpenModal';
import AudioSlice from "../components/AudioPlayer/reducers/AudioSlice";
import ThemeSlideColorSlice from './ThemeSlideColorSlice';
import { reducer as formReducer } from 'redux-form';
import TagAdminSlice from './tagAdminSlice';
import LockerSlice from './LockerSlice';
import ProfileFoldersSlice from './ProfileFoldersSlice';
import CompetitionProjects from './CompetitionProjects';
import ApplicationFormSlice from './ApplicationFormSlice';
import chatSlice from './ChatSlice';
import { isServer } from 'shared/constants/isServer';
import { createSlice } from '@reduxjs/toolkit';
import { lazy } from 'react';
import feedTagsSlice from './FeedTagsSlice';
import userChannelSlice from './UserChannelSlice';
import chapterPagerSlice from './ChapterPagerSlice';
import profileSlice from './profileSlice';
// const mockSlice = createSlice({ name: 'projectsGrid', initialState: {}, reducers: {} });
// const projectsGridSlice = isServer ? mockSlice : lazy(() => import('./ProjectsGridSlice' as any));

export const slices = {
  lang: langSlice.reducer,
  research: researchSlice.reducer,
  vt: vtSlice.reducer,
  stage: stageSlice.reducer,
  competitions: competitionsSlice.reducer,
  competitionProjects: CompetitionProjects.reducer,
  navbarSearch: navbarSearchSlice.reducer,
  organizations: OrganizationsSlice.reducer,
  projects: InfinityProjectsSlice.reducer,
  tags: TagsSlice.reducer,
  openModal: OpenModalSlice.reducer,
  animations: animatorSlice.reducer,
  contextList: HseContextListSlice.reducer,
  teams: TeamsSlice.reducer,
  maps: MapsSlice.reducer,
  geoTagModal: GeoTagModalStateSlice.reducer,
  currentProject: CurrentProject.reducer,
  mobileMenuOpen: MobileMenuModalStateSlice.reducer,
  //@ts-ignore
  projectsGrid: ProjectsGridSlice.reducer,
  courseInfo: CourseInfoListSlice.reducer,
  tagPage: TagPageSlice.reducer,
  order: orderSlice.reducer,
  profile: profileSlice.reducer,
  lms: LMSSlice.reducer,
  audio: AudioSlice.reducer,
  getSharedData: commonSlice.reducer,
  getUserCurrencies: userCurrenciesSlice.reducer,
  sendGift: sendGiftSlice.reducer,
  wideCover: WideCoverSlice.reducer,
  slideColor: ThemeSlideColorSlice.reducer,
  form: formReducer,
  tagAdmin: TagAdminSlice.reducer,
  lock: LockerSlice.reducer,
  folders: ProfileFoldersSlice.reducer,
  applicationForm: ApplicationFormSlice.reducer,
  chat: chatSlice.reducer,
  feedTags: feedTagsSlice.reducer,
  channel: userChannelSlice.reducer,
  chapterPager: chapterPagerSlice.reducer
};
import researchSlice from './ResearchSlice';
import vtSlice from './ViewTypeSlice';
import stageSlice from './CompetitonStageSlice';
import competitionsSlice from './Competitions'
import animatorSlice from './AnimatorSlice'
import TagsSlice from './Tags';
import navbarSearchSlice from './NavbarSearch';
import InfinityProjectsSlice from './InfinityProjects';
import HseContextListSlice from './hseCurrentContext';
import TeamsSlice from './Teams/TeamsSlice';
import langSlice from 'shared/components/__ADDONS__/__LANG__/Slice';
import GeoTagModalStateSlice from './geoTagsModal';
import CurrentProject from "./CurrentProject";
import MobileMenuModalStateSlice from './mobileMenuOpen';
import MapsSlice from "./MapsSlice";
import OrganizationsSlice from "./OrganizationsSlice";
import ProjectsGridSlice from "./ProjectsGridSlice";
import CourseInfoListSlice from './CourseInfoListSlice';
import orderSlice from "../features/QueuePaymenrt/slices/OrderSlice";
import userCurrenciesSlice from "../features/QueuePaymenrt/slices/userCurrenciesSlice";
import sendGiftSlice from "../features/QueuePaymenrt/slices/SendGiftSlice";
import commonSlice from "../features/QueuePaymenrt/slices/commonSlice";
import WideCoverSlice from './WideCoverSlice';
import LMSSlice from "./LMSSlice";
import TagPageSlice from './TagPageSlice';
import OpenModalSlice from './OpenModal';
import AudioSlice from "../components/AudioPlayer/reducers/AudioSlice";
import ThemeSlideColorSlice from './ThemeSlideColorSlice';
import { reducer as formReducer } from 'redux-form';
import TagAdminSlice from './tagAdminSlice';
import LockerSlice from './LockerSlice';
import ProfileFoldersSlice from './ProfileFoldersSlice';
import CompetitionProjects from './CompetitionProjects';
import ApplicationFormSlice from './ApplicationFormSlice';
import chatSlice from './ChatSlice';
import { isServer } from 'shared/constants/isServer';
import { createSlice } from '@reduxjs/toolkit';
import { lazy } from 'react';
import feedTagsSlice from './FeedTagsSlice';
import userChannelSlice from './UserChannelSlice';
import chapterPagerSlice from './ChapterPagerSlice';
import profileSlice from './profileSlice';
// const mockSlice = createSlice({ name: 'projectsGrid', initialState: {}, reducers: {} });
// const projectsGridSlice = isServer ? mockSlice : lazy(() => import('./ProjectsGridSlice' as any));

export const slices = {
  lang: langSlice.reducer,
  research: researchSlice.reducer,
  vt: vtSlice.reducer,
  stage: stageSlice.reducer,
  competitions: competitionsSlice.reducer,
  competitionProjects: CompetitionProjects.reducer,
  navbarSearch: navbarSearchSlice.reducer,
  organizations: OrganizationsSlice.reducer,
  projects: InfinityProjectsSlice.reducer,
  tags: TagsSlice.reducer,
  openModal: OpenModalSlice.reducer,
  animations: animatorSlice.reducer,
  contextList: HseContextListSlice.reducer,
  teams: TeamsSlice.reducer,
  maps: MapsSlice.reducer,
  geoTagModal: GeoTagModalStateSlice.reducer,
  currentProject: CurrentProject.reducer,
  mobileMenuOpen: MobileMenuModalStateSlice.reducer,
  //@ts-ignore
  projectsGrid: ProjectsGridSlice.reducer,
  courseInfo: CourseInfoListSlice.reducer,
  tagPage: TagPageSlice.reducer,
  order: orderSlice.reducer,
  profile: profileSlice.reducer,
  lms: LMSSlice.reducer,
  audio: AudioSlice.reducer,
  getSharedData: commonSlice.reducer,
  getUserCurrencies: userCurrenciesSlice.reducer,
  sendGift: sendGiftSlice.reducer,
  wideCover: WideCoverSlice.reducer,
  slideColor: ThemeSlideColorSlice.reducer,
  form: formReducer,
  tagAdmin: TagAdminSlice.reducer,
  lock: LockerSlice.reducer,
  folders: ProfileFoldersSlice.reducer,
  applicationForm: ApplicationFormSlice.reducer,
  chat: chatSlice.reducer,
  feedTags: feedTagsSlice.reducer,
  channel: userChannelSlice.reducer,
  chapterPager: chapterPagerSlice.reducer
};
